import { Box, Paper, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { useAuth } from "../../authentication/AuthProvider";
import RefreshButton from "../../components/button/RefreshButton";
import PivotablePieChart from "../../components/chart/PivotablePieChart";
import { MainContainer } from "../../components/container/MainContainer";
import { PageTitleContainer } from "../../components/container/PageTitleContainer";
import { TableHeaderContainer } from "../../components/container/TableHeaderContainer";
import { TableHeaderToolsContainer } from "../../components/container/TableHeaderToolsContainer";
import { TableTitleContainer } from "../../components/container/TableTitleContainer";
import ExportAsXLSXButton from "../../components/export/ExportAsXLSXButton";
import DateSelector from "../../components/input/DateSelector";
import { useContextProvider } from "../../components/page-context/ContextProvider";
import { ProductPassportVisitLog } from "../../db_access/product_passport_visit_log";
const DPP_Stats = () => {
  const { t } = useTranslation();
  const { refresh, setRefresh } = useContextProvider();
  const mine = { label: "Mine", value: "Mine" };
  const colleague = { label: "Colleague", value: "Colleague" };
  let tabs = [mine];
  const published = { label: "Published", value: "Published" };
  const pending = { label: "Pending", value: "Pending" };
  const subTabs = [published, pending];
  const [selectedTab, setSelectedTab] = useState(mine.value);
  const [selectedSubTab, setSelectedSubTab] = useState(published.value);
  const [stats, setStats] = useState([]);
  const [timedStats, setTimedStats] = useState([]);
  const [startDate, setStartDate] = useState(dayjs().startOf("month"));
  const [endDate, setEndDate] = useState(dayjs());
  const [searchText, setSearchText] = useState("");
  const { user } = useAuth();
  const is_Mine = () => selectedTab === mine.value;
  const is_Colleague = () => selectedTab === colleague.value;
  const is_Published = () => selectedSubTab === published.value;
  const is_Pending = () => selectedSubTab === pending.value;
  const is_CAdmin = () => user["is_company_admin"] === 1;
  const categories = [
    { label: "Continent", value: "continent_code" },
    { label: "Country", value: "country_name" },
    { label: "Region", value: "region" },
    { label: "City", value: "city" },
    { label: "Device Type", value: "device_type" },
    { label: "Device OS", value: "device_os" },
    { label: "Product", value: "product_name" },
  ];
  if (is_CAdmin()) {
    tabs.push(colleague);
  }
  const getStats = () => {
    ProductPassportVisitLog.getAllMineCompany()
      .then((res) => res.json())
      .then((data) => setStats(data));
  };
  useEffect(() => getStats(), [refresh]);
  useEffect(() => console.log(stats), [stats]);
  useEffect(() => {
    const filtered = stats.filter((s) => {
      const ts = dayjs(s.timestamp);
      return ts.isAfter(startDate) && ts.isBefore(endDate);
    });
    setTimedStats(filtered);
  }, [stats, startDate, endDate]);
  return (
    <MainContainer>
      <PageTitleContainer>
        <Box>
          <Box>
            <Typography variant="Page Title">{t("Digital Product Passports Statistic")}</Typography>
          </Box>
          <Box>
            <Typography variant="Page Subtitle">{t("Digital Product Passports Statistic")}</Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: 0.5,
            backgroundColor: "rgba(23, 163, 74, 0.2)",
            marginTop: 0.4,
            marginBottom: "auto",
            paddingLeft: 1,
            paddingRight: 1.5,
            paddingY: 0.5,
            borderRadius: 4,
            alignItems: "center",
          }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IoMdCheckmarkCircleOutline color="#166534" size={20} />
          </Box>
          <Typography sx={{ fontFamily: "Poppins", color: "#166534", paddingTop: 0.1 }}>{t("EU Regulation Compliant")}</Typography>
        </Box>
      </PageTitleContainer>
      <Paper variant="Table Container">
        <TableHeaderContainer>
          <TableTitleContainer>
            <Typography variant="Table Title">{t("Digital Product Passports Statistic")}</Typography>
          </TableTitleContainer>
          <TableHeaderToolsContainer>
            <ExportAsXLSXButton data={stats} label="Download Visits" filename="visits.xlsx" />
            <RefreshButton />
          </TableHeaderToolsContainer>
        </TableHeaderContainer>
        <Box sx={{ padding: 2 }}>
          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
            <Box sx={{ flex: 1 }}>
              <DateSelector label={"Start Date"} value={startDate} onChange={(newValue) => setStartDate(newValue)} />
            </Box>
            <Box sx={{ flex: 1 }}>
              <DateSelector label={"End Date"} value={endDate} onChange={(newValue) => setEndDate(newValue)} />
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", justifyContent: "center" }}>
            {categories.map((c, i) => (
              <Box key={i} sx={{ width: 500, height: 500 }}>
                <PivotablePieChart title={`Visits by ${c.label}`} usages={timedStats} groupBy={c.value} />
              </Box>
            ))}
          </Box>
        </Box>
      </Paper>
    </MainContainer>
  );
};
export default DPP_Stats;
